import { useState, useEffect } from 'react'
import { useAuth } from '../auth/AuthContext'
import { ApiError } from '../api/client'
import type { SchemaResponse } from '../api/types'

interface UseSchemaResult {
  schema: SchemaResponse | null
  loading: boolean
  error: string | null
  refetch: () => Promise<void>
}

export function useSchema(): UseSchemaResult {
  const { apiClient } = useAuth()
  const [schema, setSchema] = useState<SchemaResponse | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchSchema = async () => {
    if (!apiClient) return

    try {
      setLoading(true)
      setError(null)
      const data = await apiClient.getSchema()
      setSchema(data)
    } catch (err) {
      if (err instanceof ApiError) {
        setError(err.message)
      } else {
        setError('Failed to load schema')
      }
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchSchema()
  }, [apiClient])

  return { schema, loading, error, refetch: fetchSchema }
}
